export function formatSecondsToHMS(seconds: number) {
  const parsedSeconds = seconds <= 0 ? 0 : seconds;
  const hours = Math.floor(parsedSeconds / 3600);
  const minutes = Math.floor((parsedSeconds - hours * 3600) / 60);

  const hoursString = hours > 0 ? `${('0' + hours).slice(-2)}:` : '';
  const minutesString = minutes > 0 ? `${('0' + minutes).slice(-2)}:` : '00:';
  const secondsString = `${('0' + Math.floor(parsedSeconds % 60)).slice(-2)}`;

  return `${hoursString}${minutesString}${secondsString}`;
}
